import BaseButton from 'components/atoms/baseButton';
import BoxArrowUpTopIcon from 'assets/img/icons/box-arrow-up-top.svg?react';
import { useEffect, useReducer, type FC } from 'react';
import DraggableModal from 'components/organisms/draggableModal';

import s from './styles.module.scss';
import ThresholdCell from '../threshold-cell';
import ReadingCell from '../reading-cell';
import LinkedCalls from './linkedCalls';

import type { IPatientThresholds } from 'infrastructure/interfaces';
import type {
  ILinkedReadingCall,
  TStatuses,
  TThresholdName,
  Value,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { Nullable } from 'infrastructure/types';
import type { ReadingStatus, ReadingType } from 'infrastructure/enums';

interface LinkedCallsCellProps {
  linkedCalls: ILinkedReadingCall[];
  title: string;
  subtitle: string;
  values: Value;
  statuses: TStatuses;
  readingType: ReadingType;
  globalStatus: ReadingStatus;
  thresholds: IPatientThresholds;
  thresholdName?: Nullable<TThresholdName>;
  page: number;
  patientTimezone: string;
  patientPhone: string;
  patientName: string;
  patientGuid: string;
}

const LinkedCallsCell: FC<LinkedCallsCellProps> = ({
  linkedCalls,
  title,
  subtitle,
  values,
  statuses,
  readingType,
  globalStatus,
  thresholds,
  thresholdName,
  patientGuid,
  patientName,
  patientPhone,
  patientTimezone,
  page,
}) => {
  const [open, toggle] = useReducer((v) => !v, false);

  const count = linkedCalls.length;

  useEffect(() => {
    if (open) toggle();
  }, [page]);

  return (
    <div>
      <BaseButton
        label={`${count} Linked Calls`}
        type="secondary"
        rightIcon={
          <div className={s['comment-icon-wrapper']}>
            <BoxArrowUpTopIcon className={s['comment-icon']} />
          </div>
        }
        className={s['comment-btn']}
        onClick={toggle}
        disabled={!count}
      />
      {open && (
        <DraggableModal
          title={title}
          subTitle={subtitle}
          isOpen={open}
          toggle={toggle}
          footer={false}
          titleClassName={s['modal-title']}
          subTitleClassName={s['modal-subtitle']}
          withStackOffset
          subHeader={
            <div className={s['sub-header']}>
              <ReadingCell
                values={values}
                statuses={statuses}
                readingType={readingType}
              />
              <ThresholdCell
                values={values}
                statuses={statuses}
                readingType={readingType}
                globalStatus={globalStatus}
                thresholds={thresholds}
                thresholdName={thresholdName}
              />
            </div>
          }
        >
          <LinkedCalls
            linkedCalls={linkedCalls}
            globalStatus={globalStatus}
            values={values}
            statuses={statuses}
            thresholds={thresholds}
            readingType={readingType}
            thresholdName={thresholdName}
            patientGuid={patientGuid}
            patientName={patientName}
            patientPhone={patientPhone}
            patientTimezone={patientTimezone}
          />
        </DraggableModal>
      )}
    </div>
  );
};
export default LinkedCallsCell;
